import './downloadLink.scss';
import * as React from 'react';
import { Assets } from '../../content/assets';
export const DownloadLink = ({ platform, href }) => (<a className={`download-link download-link-${platform}`} href={href} target="_blank" rel="noopener noreferrer">
    {platform === 'android' && <img alt="get it on google play" src={Assets.downloads.playStore}/>}
    {platform === 'ios' && <img alt="download it on the app store" src={Assets.downloads.appStore}/>}
  </a>);
